import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=7ae41291&scoped=true&"
import script from "./CourseInfo.vue?vue&type=script&lang=js&"
export * from "./CourseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfo.vue?vue&type=style&index=0&id=7ae41291&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae41291",
  null
  
)

export default component.exports